import React from 'react';
import './Pages/PagesCss/PrivacyPolicy.css';

const About = () => {

  const values = [
  {
    icon: "fa-solid fa-calculator",
    title: "Accuracy You Can Trust",
    description: "Every calculation follows real-world financial formulas to help you make informed decisions."
  },
  {
    icon: "fa-solid fa-user-graduate",
    title: "Educational Approach",
    description: "We explain every term and result, turning numbers into meaningful insights."
  },
  {
    icon: "fa-solid fa-lock",
    title: "Privacy and Transparency",
    description: "We don’t store or share your data. Everything runs securely and privately on your device."
  },
  {
    icon: "fa-solid fa-chart-line",
    title: "Constant Improvement",
    description: "We refine and expand our calculators based on feedback and new financial trends."
  }
];

  const milestones = [
  { year: "2024", title: "Concept & Foundation", description: "CreditsIQ was created to make credit calculations simple for everyone." },
  { year: "2025", title: "Launch", description: "Introduced tools like the Credit Card Payoff and Interest Calculators." },
  { year: "2025", title: "Expansion", description: "Added DTI Ratio, Balance Transfer, and Utilization Ratio Calculators." },
  { year: "2025", title: "Community Growth", description: "Reached thousands of monthly users improving their credit confidence." },
];


  return (
    <div className="privacy-policy">
      {/* Header Section */}
      <section className="contact-header">
        <div className="container">
          <div className="header-content">
            <h1>About CreditsIQ</h1>
            <p className="header-description">
              CreditsIQ helps users take control of their credit and debt with simple, accurate, and educational calculators. 
  Whether you're paying off cards, comparing transfers, or improving your credit score, we make it easier to understand your finances.
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="policy-content">
        <div className="container">
          <div className="policy-grid">
            {/* Quick Navigation */}
            <aside className="table-of-contents">
              <h3>Quick Navigation</h3>
              <nav>
                <ul>
                  <li><a href="#our-story">Our Story</a></li>
                  <li><a href="#our-mission">Our Mission</a></li>
                  <li><a href="#our-values">Our Values</a></li>
                  <li><a href="#our-journey">Our Journey</a></li>
                  <li><a href="#educational-philosophy">Educational Philosophy</a></li>
                  <li><a href="#contact">Get In Touch</a></li>
                </ul>
              </nav>
            </aside>

            {/* Main Content */}
            <div className="policy-sections">
              <section id="our-story" className="policy-section">
                <h2>Our Story</h2>
                <div className="section-content">
                  <div className="security-features">
                    <h3>From Confusion to Clarity</h3>
                    <p>
                      <strong>creditsiq was born from a simple observation:</strong> too many people 
                      feel overwhelmed by financial complexity. We believe everyone deserves 
                      access to clear, reliable financial tools that empower rather than confuse.
                    </p>
                  </div>

                  <p>
                    Founded in 2025 by Darshan, our journey began when we noticed many people 
  struggling with basic financial calculations. Existing tools were either too simple 
  or overly complex, often lacking proper educational context.
                  </p>

                  <p>
  creditsiq was created to provide clear, reliable tools that educate rather than confuse, 
  helping users worldwide build financial confidence.
</p>
                </div>
              </section>

              <section id="our-mission" className="policy-section">
                <h2>Our Mission & Vision</h2>
                <div className="section-content">
                  <h3>Our Mission</h3>
                  <p>
                    To simplify credit and debt management for everyone through accurate, easy-to-use tools. 
Our goal is to help users understand how credit cards, interest rates, and balances affect their financial health.
                  </p>

                  <h3>Our Vision</h3>
                  <p>
                    Our platform includes <a href="https://creditsiq.com" target="_blank" rel="noopener noreferrer">creditsiq.com</a> and its blog <a href="https://blog.creditsiq.com" target="_blank" rel="noopener noreferrer">blog.creditsiq.com</a>, providing educational resources for all levels of learners.
                  </p>

                  <div className="rights-grid">
                    <div className="right-item">
                      <h4>Education First</h4>
                      <p>Tools designed for learning, not just calculating</p>
                    </div>
                    <div className="right-item">
                      <h4>Accessibility</h4>
                      <p>Complex concepts made simple and approachable</p>
                    </div>
                    <div className="right-item">
                      <h4>Empowerment</h4>
                      <p>Building confidence through understanding</p>
                    </div>
                    <div className="right-item">
                      <h4>Innovation</h4>
                      <p>Continually improving our educational approach</p>
                    </div>
                  </div>
                </div>
              </section>

              <section id="our-values" className="policy-section">
                <h2>Our Values</h2>
                <div className="section-content">
                  <p>
                    These core values guide everything we do, from calculator development 
                    to user support and content creation.
                  </p>

                  <div className="values-grid">
                    {values.map((value, index) => (
                      <div key={index} className="value-item">
                        <div className="value-icon"><i class={value.icon}></i></div>
                        <div className="value-content">
                          <h4>{value.title}</h4>
                          <p>{value.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="security-features">
                    <h3>Educational Integrity</h3>
                    <p>
                      <strong>We never provide financial advice or recommendations.</strong> 
                      Our role is to educate and empower you to have more informed conversations 
                      with qualified financial professionals.
                    </p>
                  </div>
                </div>
              </section>

              <section id="our-journey" className="policy-section">
                <h2>Our Journey</h2>
                <div className="section-content">
                  <p>
                    From our founding to today, here are the key milestones in our journey 
                    to make financial education more accessible.
                  </p>

                  <div className="timeline">
                    {milestones.map((milestone, index) => (
                      <div key={index} className="timeline-item">
                        <div className="timeline-year">{milestone.year}</div>
                        <div className="timeline-content">
                          <h4>{milestone.title}</h4>
                          <p>{milestone.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="security-features">
                    <h3>Looking Ahead</h3>
                    <p>
                      <strong>Our journey continues with new calculators, improved educational 
                      content, and enhanced user experiences.</strong> We're committed to evolving 
                      with our users' needs and the changing financial landscape.
                    </p>
                  </div>
                </div>
              </section>

              <section id="educational-philosophy" className="policy-section">
                <h2>Educational Philosophy</h2>
                <div className="section-content">
                  <h3>Learning Through Doing</h3>
                  <p>
                    We believe that interactive learning through calculators helps build 
                    deeper understanding than passive reading alone. Our approach combines:
                  </p>

                  <p>
Our most popular tools include the Credit Card Payoff Calculator, Minimum Payment Interest Calculator, 
and Balance Transfer Savings Calculator each designed to turn complex math into clear insights.
</p>


                  <div className="rights-grid">
                    <div className="right-item">
                      <h4>Interactive Tools</h4>
                      <p>Hands-on calculators that demonstrate financial principles</p>
                    </div>
                    <div className="right-item">
                      <h4>Clear Explanations</h4>
                      <p>Simple language that makes complex concepts accessible</p>
                    </div>
                    <div className="right-item">
                      <h4>Real Context</h4>
                      <p>Practical examples that show how calculations apply to real life</p>
                    </div>
                    <div className="right-item">
                      <h4>Progressive Learning</h4>
                      <p>Tools that grow with your understanding and confidence</p>
                    </div>
                  </div>

                  <h3>What Makes Us Different</h3>
                  <p>
                    Unlike many other financial websites, creditsiq focuses solely on education. 
  We do not sell products, manage investments, or provide personal advice, 
  ensuring complete objectivity and a learning-first experience.
                  </p>

                  <div className="security-features">
                    <h3>No Conflicts of Interest</h3>
                    <p>
                      <strong>We don't sell financial products or manage investments.</strong> 
                      This means our only incentive is to provide the best possible 
                      educational experience. Your learning is our success metric.
                    </p>
                  </div>
                </div>
              </section>

              <section id="contact" className="policy-section">
                <h2>Get In Touch</h2>
                <div className="section-content">
                  <p>
                    We love hearing from our users! Whether you have feedback, suggestions, 
                    or just want to share your learning journey, we're here to listen.
                  </p>

                  <div className="contact-info">
                    <div className="contact-item">
                      <strong>General Inquiries:</strong> support@creditsiq.com
                    </div>
                    <div className="contact-item">
                      <strong>Address:</strong> 2568 Madison Ave, League City, TX 77573
                    </div>
                  </div>

                  <div className="security-features">
                    <h3>Join Our Community</h3>
                    <p>
                      <strong>Your feedback shapes our platform.</strong> Thousands of our 
                      current features started as user suggestions. Help us continue to 
                      improve financial education for everyone.
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="policy-actions">
        <div className="container">
          <div className="actions-content">
            <h3>Start Your Financial Learning Journey</h3>
            <p>Use our calculators to plan payments, compare cards, and understand interest all in one place.</p>
            <div className="action-buttons">
              <a href="/ShortLongCalculator" className="btn btn-primary">Browse Calculators</a>
              <a href="/Contact" className="btn btn-secondary">Share Your Story</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;